import { dscvrIcApi } from '@/shared/api';

export const useCreateSignedQuery = (actionBody: string) => {
  return dscvrIcApi.frame.createSignedQuery(actionBody);
};
